import React, { useMemo } from 'react';

import {
  Row,
  Col,
  Button,
} from 'reactstrap';

import FieldError from '../../../../../../helper/FieldError';

import WorkflowHttpRequestBodyRequestContentItemForm from './item_form';

const WorkflowHttpRequestBodyRequestContentList = props => {
  const { currentNode } = props;
  const {
    callbacks: {
      onAddBodyRequestContentItem: callbackOnAddBodyRequestContentItem,
      onChangeBodyRequestContentItem: callbackOnChangeBodyRequestContentItem,
      onRemoveBodyRequestContentItem,
      activeInputStageFileItems
    }
  } = props;

  const bodyRequestContent = useMemo(() => {
    return currentNode?.data?.body_request_content || [];
  }, [currentNode?.data?.body_request_content])

  return(
    <Row>
      <Col md={ 12 }>
        <FieldError errors={ _.get(currentNode, 'data.errors.body_request_content') }/>
        { _.map(bodyRequestContent, (bodyRequestContentItem, index) => {
          return(
            <WorkflowHttpRequestBodyRequestContentItemForm
              key={ `WorkflowHttpRequestBodyRequestContentItemForm-${ bodyRequestContentItem?.custom_id }` }
              currentNode={ currentNode }
              bodyRequestContentItem={ bodyRequestContentItem }
              callbacks={{
                onChangeBodyRequestContentItem: callbackOnChangeBodyRequestContentItem,
                activeInputStageFileItems: activeInputStageFileItems,
                onRemoveBodyRequestContentItem: onRemoveBodyRequestContentItem
              }}
            />
          )
        })}
        <div className='text-center'>
          <Button
            outline
            color='success'
            size="sm"
            onClick={ callbackOnAddBodyRequestContentItem }
          >
            Add Body Request Content Item
          </Button>
        </div>
      </Col>
    </Row>
  )
}

export default WorkflowHttpRequestBodyRequestContentList;
